import React from 'react'
import { Link } from 'react-router-dom'
import { CreditHistory, HistoryType } from '../../../models/Credit'
import { convertDateFormat } from '../../../utility/stringUtils'
import styles from './creditHistoryItem.module.css'

interface CreditHistoryItemProps {
  history: CreditHistory
  avatarUrl: string
}

const CreditHistoryItem = ({ history, avatarUrl }: CreditHistoryItemProps) => {
  return (
    <div
      className={`${styles.rowContainer} ${styles[history.type]}`}
      data-testid="creditHistoryItem"
    >
      <div className={styles.avatarWrapper}>
        {history.type === HistoryType.add ||
        history.type === HistoryType.deduct ? (
          <img
            data-testid="bigMochiAvatar"
            className={styles.avatar}
            src="bigmochi-avatar.jpg"
            alt="BigMochi"
          />
        ) : (
          <img
            data-testid="userAvatar"
            className={styles.avatar}
            src={avatarUrl}
            alt="You"
          />
        )}
      </div>
      <div className={styles.infoWrapper}>
        <div data-testid="authorName" className={styles.author}>
          {history.author}
        </div>
        <div
          className={
            history.type === HistoryType.add ? styles.positive : styles.negative
          }
        >
          {history.type === HistoryType.add ? (
            <>
              <span className={styles.grayText} data-testid="sentYou">
                sent you
              </span>{' '}
              +
            </>
          ) : (
            <>
              {history.type === HistoryType.deduct ? (
                <>
                  <span className={styles.grayText} data-testid="redeemed">
                    redeemed
                  </span>{' '}
                  -
                </>
              ) : (
                <Link to={`/orders/${history.metadata.orderId}`}>
                  <span className={styles.grayText} data-testid="paidFor">
                    paid an order for
                  </span>{' '}
                  -
                </Link>
              )}
            </>
          )}
          <span data-testid="amount">{history.amount.toLocaleString()}</span>{' '}
          BMC
        </div>
      </div>
      <div className={styles.dateWrapper}>
        <span data-testid="date">{convertDateFormat(history.date)}</span>
      </div>
    </div>
  )
}

export default CreditHistoryItem
